<!--
  Panel — the standard ShioCast surface. Cards do not glow at rest; `onAir` is the one
  variant that carries a strong glow, and only one element per screen may use it.
-->
<script setup lang="ts">
withDefaults(
  defineProps<{
    title?: string;
    interactive?: boolean;
    onAir?: boolean;
    padded?: boolean;
  }>(),
  { interactive: false, onAir: false, padded: true },
);
</script>

<template>
  <section
    class="shio-panel"
    :class="{
      'shio-panel--interactive': interactive,
      'shio-panel--onair': onAir,
    }"
  >
    <header v-if="title || $slots.actions" class="shio-panel__header">
      <h2 v-if="title" class="shio-section">{{ title }}</h2>
      <slot v-else name="title" />
      <div v-if="$slots.actions" class="shio-panel__actions">
        <slot name="actions" />
      </div>
    </header>
    <div :class="padded ? 'shio-panel__body' : undefined"><slot /></div>
  </section>
</template>

<style scoped>
.shio-panel__actions {
  display: flex;
  align-items: center;
  gap: var(--shio-space-2);
}
</style>
